import { ApolloError } from '@apollo/client';
import { Divider, Skeleton, Stack } from '@cmg/design-system';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import React from 'react';

import { SNotFound } from '../../common/components/errorRenderer/SNotFound/SNotFound';
import ServerErrorsBanner from '../../common/components/indicators/server-error/ServerErrorsBanner';
import { OfferingType } from '../../graphql';
import { parsePartialErrors } from '../../graphql/parsePartialErrors';
import { SidePanelTitle } from './components/side-bar/components/design-system/SidePanelTitle';
import ConvertibleOfferingStatusIndicator from './components/side-bar/components/offering-status-indicator/ConvertibleOfferingStatusIndicator';
import OfferingStatusIndicator from './components/side-bar/components/offering-status-indicator/OfferingStatusIndicator';
import { useSideBar_OfferingDetails_OfferingQuery } from './components/side-bar/graphql';
import { useOfferingSidePanelOfferingId } from './hooks/useOfferingSidePanelMatch';

const EMPTY_ARRAY = [];

export function OfferingSidePanelSummaryRoute() {
  const offeringId = useOfferingSidePanelOfferingId();
  const { data, error, loading } = useSideBar_OfferingDetails_OfferingQuery({
    variables: { offeringId },
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });
  const [publishedOffering] = data?.publishedOfferings?.items ?? EMPTY_ARRAY;

  if (isNil(publishedOffering) && !loading && !error) {
    return <SNotFound />;
  }

  const classifiedErrors = parsePartialErrors(error);

  if (!isEmpty(classifiedErrors?.errors)) {
    return (
      <ServerErrorsBanner error={new ApolloError({ graphQLErrors: classifiedErrors?.errors })} />
    );
  }

  if (loading) {
    return (
      <Stack spacing={1} role="progressbar">
        <Divider />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Divider />
        <Skeleton variant="rectangular" height={118} />
      </Stack>
    );
  }

  return (
    <Stack>
      <SidePanelTitle>Summary</SidePanelTitle>
      <Divider />
      {publishedOffering.type === OfferingType.Convertible ? (
        <ConvertibleOfferingStatusIndicator
          publishedOffering={publishedOffering}
          loading={loading}
        />
      ) : (
        <OfferingStatusIndicator publishedOffering={publishedOffering} isBusy={loading} />
      )}
    </Stack>
  );
}
